import { render, staticRenderFns } from "./NewBackPay.vue?vue&type=template&id=373470bd"
import script from "./NewBackPay.vue?vue&type=script&lang=js"
export * from "./NewBackPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports